var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1558)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_1558",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1757 36C28.1168 36 36.1757 27.9411 36.1757 18C36.1757 8.05887 28.1168 0 18.1757 0C8.23453 0 0.175659 8.05887 0.175659 18C0.175659 27.9411 8.23453 36 18.1757 36Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1757 36C28.1168 36 36.1757 27.9411 36.1757 18C36.1757 8.05887 28.1168 0 18.1757 0C8.23453 0 0.175659 8.05887 0.175659 18C0.175659 27.9411 8.23453 36 18.1757 36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0773 31.504L14.0041 10.8H10.9757V25.194H13.3984V13.8767L28.1755 32.969C28.8423 32.5228 29.4775 32.033 30.0773 31.504Z",
    fill: "url(#paint0_linear_55_1558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5757 10.8H23.1757V25.2H25.5757V10.8Z",
    fill: "url(#paint1_linear_55_1558)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_1558",
    x1: 1073.65,
    y1: 1260.8,
    x2: 1711.54,
    y2: 2051.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_1558",
    x1: 143.176,
    y1: 10.8,
    x2: 139.156,
    y2: 1068.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.175659)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.aceb39101bd0d9cb5f3e3f662b653ffd.svg";
export { ForwardRef as ReactComponent };